import ApplicationComponent from "legacy/ApplicationComponent"
import LoadingView from "legacy/LoadingView"
import Paginator from "legacy/Paginator"
import { centsToDollars, humanize } from "legacy/helpers.es6"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

import Badge from "src/components/Badge"
import { statusToken } from "src/components/Badge/status_tokens"

class SalesHistory extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.isFailed = this.isFailed.bind(this)
    this.isPaid = this.isPaid.bind(this)
    this.renderPrice = this.renderPrice.bind(this)
    this.renderCustomer = this.renderCustomer.bind(this)
    this.renderSale = this.renderSale.bind(this)
    this.renderContent = this.renderContent.bind(this)
  }

  isFailed(sale) {
    return sale.status === "failed"
  }

  isPaid(sale) {
    return sale.status === "paid"
  }

  renderPrice(sale) {
    const price = this.isFailed(sale)
      ? centsToDollars(sale.refundedAmount)
      : centsToDollars(sale.totalPrice)
    let className = "col-start-3"
    if (this.isPaid(sale)) {
      className = "col-start-4"
    } else if (this.isFailed(sale)) {
      className = "text-red-700 col-start-3"
    }

    return <p className={`m-0 justify-self-end ${className}`}>{price}</p>
  }

  renderCustomer(sale) {
    if (sale.contact) {
      return sale.contact.name || "-"
    } else {
      return "Guest"
    }
  }

  renderSale(sale) {
    return (
      <div key={sale.id}>
        <div
          role="button"
          onClick={() => this.props.setSelectedSale(sale)}
          onKeyPress={() => this.props.setSelectedSale(sale)}
          tabIndex="0"
          className={`border py-3 ${
            this.props.selectedSale && this.props.selectedSale.id === sale.id
              ? "relative z-10 -m-px -mx-4 border-blue-600 bg-blue-50 px-4"
              : "border-transparent bg-white"
          }`}
        >
          <div className="grid grid-cols-4 gap-y-3">
            <p className="m-0 justify-self-start font-bold">#{sale.id}</p>
            <p className="col-span-full col-start-2 m-0 justify-self-end">
              {moment(sale.createdAt).format("MMMM D YYYY, HH:mm")}
            </p>
            <p className="col-span-2 m-0 justify-self-start">
              {this.renderCustomer(sale)}
            </p>
            {this.renderPrice(sale)}
            {!this.isPaid(sale) && (
              <div className="col-start-4 justify-self-end">
                <Badge
                  color={statusToken(sale.status)}
                  text={humanize(sale.status)}
                />
              </div>
            )}
          </div>
        </div>
        <hr className="m-0" />
      </div>
    )
  }

  renderContent() {
    if (this.props.isLoading) {
      return <LoadingView name="Sales" />
    } else if (this.props.errorMessage) {
      return <p className="italics">{this.props.errorMessage}</p>
    } else {
      return this.props.sales.map((sale) => {
        return this.renderSale(sale)
      })
    }
  }

  render() {
    return (
      <div>
        <h2 className="text-base font-semibold">History</h2>
        <hr className="mb-0" />
        {this.renderContent()}
        <div className="h-8" />
        <div className="absolute inset-x-0 bottom-0 p-2">
          <Paginator
            page={this.props.page}
            numberOfPages={this.props.numberOfPages}
            totalItemsCount={this.props.totalSalesCount}
            goToPage={this.props.goToPage}
          />
        </div>
      </div>
    )
  }
}

SalesHistory.propTypes = {
  sales: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  errorMessage: PropTypes.string,
  selectedSale: PropTypes.object,
  page: PropTypes.number.isRequired,
  numberOfPages: PropTypes.number.isRequired,
  totalSalesCount: PropTypes.number.isRequired,
  setSelectedSale: PropTypes.func.isRequired,
  goToPage: PropTypes.func.isRequired,
}

SalesHistory.defaultProps = {
  sales: [],
  isLoading: false,
  errorMessage: "",
  selectedSale: null,
}

export default SalesHistory
